import React from 'react'
import DrawPointer from './DrawPointer'

const GraphClock: React.FunctionComponent<any> = (props) => {
  return <DrawPointer {...props} />
}

export default GraphClock
